import { Component, input } from '@angular/core';
import { PendingBranch} from '@features/dashboard/interfaces/pending-branch.interface';
import { TableModule } from "primeng/table";
import { Tag } from "primeng/tag";
import { NestedPropertyPipe } from 'src/app/shared/pipes/nested-property.pipe';

@Component({
    selector: 'app-pending-branches-today',
    imports: [TableModule, Tag, NestedPropertyPipe],
    templateUrl: './pending-branches-today.component.html',
})
export class PendingBranchesTodayComponent {

    pendingBranches = input.required<PendingBranch[]>();

    columns = [
        { field: 'branch.centro', header: 'Centro' },
        { field: 'branch.descripcion_centro', header: 'Sucursal' },
        { field: 'closing_date', header: 'Fecha Cierre' },
        { field: 'closing_time', header: 'Hora Cierre' },
        { field: 'status', header: 'Estatus' }
    ];

    getSeverity(status: string) {
        switch (status) {
            case 'RECEIVED':
                return 'success';
            case 'PENDING':
                return 'warn';
            default:
                return null;
        }
    }

    getStatusLabel(status: string): string {
        switch (status) {
            case 'PENDING':
                return 'PENDIENTE';
            case 'RECEIVED':
                return 'RECIBIDO';
            default:
                return status;
        }
    }
}
